import { render } from "./FuelRequests.vue?vue&type=template&id=a6d793ea"
import script from "./FuelRequests.vue?vue&type=script&lang=js"
export * from "./FuelRequests.vue?vue&type=script&lang=js"
script.render = render

export default script